import axios from "axios";
import store from "../redux/store";

const sendGDPREmail = async ({ lang, templates, trdr, email }) => {
  const state = store.getState();
  const clientID = state.auth.clientID;

  return await axios
    .post(`${process.env.REACT_APP_API_ENDPOINT}/send-gdpr-email`, {
      clientID,
      format: "PDF",
      language: lang,
      templates,
      trdr,
      email,
      emailConfig: state.consentEmailConfig,
      appID: process.env.REACT_APP_S1_APPID,
    })
    .then((res) => res.data)
    .catch((er) => ({ success: false, error: er.message }));
};

export default sendGDPREmail;
